export type IFindDataEntryStoreValues = (
  fieldSelector: string,
  varName: string,
  fieldSuffix: string,
  returnAsDate: boolean
) => any | null;

export function findDataEntryStoreValues(
  fieldSelector: string,
  varName: string,
  fieldSuffix: string,
  returnAsDate: boolean
): any | null {
  const dataEntryStoreValues = (window as any)[varName];
  if (typeof dataEntryStoreValues === 'object') {
    for (const dataEntryStoreValue of dataEntryStoreValues) {
      if (
        (dataEntryStoreValue.fieldId &&
          dataEntryStoreValue.fieldId.toString() === fieldSelector.toString()) ||
        (dataEntryStoreValue.identifier &&
          dataEntryStoreValue.identifier.toString() === fieldSelector.toString())
      ) {
        if (returnAsDate) {
          const field = window.DexeroCoreApp.getFieldProperties(fieldSelector, fieldSuffix);
          if (field && field.dateFormat && dataEntryStoreValue.values) {
            const dateValue = dataEntryStoreValue.values;
            if (field.timeFormat) {
              const timeValue = dateValue.substring(field.dateFormat.length);
              const d = window.DexeroCoreApp.parseDate(
                field.dateFormat,
                dataEntryStoreValue.values[0].substring(0, field.dateFormat.length)
              );
              if (d) {
                d.setHours(
                  Number(
                    window.DexeroCoreApp.formatTime(
                      'hh',
                      window.DexeroCoreApp.parseTime(field.timeFormat, timeValue),
                      false
                    )
                  )
                );
                d.setMinutes(
                  Number(
                    window.DexeroCoreApp.formatTime(
                      'min',
                      window.DexeroCoreApp.parseTime(field.timeFormat, timeValue),
                      false
                    )
                  )
                );
              }
              return d;
            }
            return window.DexeroCoreApp.parseDate(field.dateFormat, dateValue);
          }
          return null;
        }
        return dataEntryStoreValue.values;
      }
    }
  }
  return null;
}
